import { Component, h, Prop, Build } from '@stencil/core';
import { product, ProductData } from "../../../global/data/product";
import { productDynamic, ProductDynamicData } from "../../../global/data/productDynamic";
import { common } from '../../../global/data/common';
import { DataLayer } from '../../../global/dataLayer';

declare global { interface Window { dataLayer: any[] }}
@Component({
    tag: 'ks-page-product',
    styleUrl: 'product.css'
})
export class PageProduct {
    @Prop() skipbase: boolean;
    @Prop() commonData: string;
    @Prop() commonDynamicData: string;

    @Prop() productData: string;
    @Prop() productDynamicData: string;

    componentWillLoad() {
        const productDataElement = document.getElementById(this.productData);
		const productData = JSON.parse(productDataElement.innerHTML) as ProductData;

        Object.keys(productData).map(key => {
			product.set(key as keyof ProductData, productData[key]);
		});

        this.setDefaultTrait();

        if (Build.isBrowser) {
            const productDynamicDataElement = document.getElementById(this.productDynamicData);
            const productDynamicData = JSON.parse(productDynamicDataElement.innerHTML) as ProductDynamicData;
    
            Object.keys(productDynamicData).map(key => {
                productDynamic.set(key as keyof ProductDynamicData, productDynamicData[key]);
            });
    
            setTimeout(() => {
                productDynamic.set("loaded", true);
            }, 100);

            this.track();
        }
    }

    setDefaultTrait() {
		if(!product?.get("traits"))	return;
		
		const traits = product.get("traits").reduce((accumulator, trait) => {
			return accumulator + "x" + trait.id + "-" + trait.items[0].id;
		}, "");

		product.set("traitIDs", traits);
	}

    track() {
        DataLayer.product(product.state, productDynamic.get("eventId"));
    }

    componentDidUpdate() {
        (window as any).handleInpostIziButtons();
    }

	render() {
        if(!product?.get('name')) return false;

        const infoBanner = product.get("infoBanner");
        const productBanner = product.get("productBanner");

        const points = product.get("points");
        const recycle = product.get("recycle");
        const installments = product.get('installments');
        const tags = product.get('tags');
        const variants = product.get('variants');

        const gspr = product.get("gspr");
        const tabs = [
            ...product.get('tabs'), 
            ...(gspr?.name || gspr?.info ?
                [{name: "Producent", gspr: gspr}] : []
            )
        ]

        const youtube = product.get('youtube');

        const similar = product.get('similar');
        const accessories = product.get('accessories');

        const model = product.get('model') || product.get('catalog');
        const ean = product.get('ean');

        const review = product.get('reviewAverage');

        const strings = product.get('strings');

		return <ks-page-base skipbase={this.skipbase} commonData={this.commonData} commonDynamicData={this.commonDynamicData}>

            {infoBanner ? 
                <ks-content-info-banner content={infoBanner} />
            : null}

            <ks-container>
                <ks-product-notify-edrone/>
                <ks-product-admin/>

                {product.get("message") ?
                    <ks-product-message/>
                :null}
                
                <ks-product-info>
                    {product.get('traits') ?
                        <ks-product-traits></ks-product-traits>
                    : null}
                
                    <ks-product-purchase
                        cartText={common.get('translations').addToCart}
                        availabilityText={strings.notifyAvailability}
                    ></ks-product-purchase>

                    <ks-product-shipping></ks-product-shipping>

                    {product.get('warranty') ? 
                        <ks-product-attribute style={{marginTop: "15px"}} icon="tool" href={product.get('warrantyLink')}>
                            {product.get('warranty')}
                        </ks-product-attribute>
                    : null}
                    
                    {points ?
                        <ks-product-tooltip message={points.message}>
                            <ks-product-attribute icon="gift">{points.shortMessage}</ks-product-attribute>
                        </ks-product-tooltip>
                    : null}

                    {recycle ?
                        <ks-product-tooltip message={recycle.message}>
                            <ks-product-attribute icon="recycle">{recycle.shortMessage}</ks-product-attribute>
                        </ks-product-tooltip>
                    : null}

                    {installments?.attributeMessage ?
                        <ks-product-attribute icon="dollar-sign">{installments?.attributeMessage}</ks-product-attribute>
                    : null}

                    {product.get("energy") && product.get("energyLabel") ? 
                        <ks-product-image-popup image={product.get("energyLabel")}>
                            <ks-product-attribute energyOld={product.get("energyOld")} energy={product.get("energy")}>Klasa energetyczna</ks-product-attribute>
                        </ks-product-image-popup>
                    : null}

                    {model || ean ?
                        <ks-product-attribute style={{marginTop: "15px"}} icon="file" >
                            <span style={{marginRight: "15px"}}>
                                {model ? <span style={{marginRight: "7px"}}>{strings.model} {model} </span> : null}
                                {ean ? <span>{strings.ean} {ean}</span> : null}
                            </span>
                        </ks-product-attribute>
                    : null}

                    <div class="buttons">
                        {product.get('negotiateEnabled') ?
                            <ks-product-negotiate>
                                <ks-product-button>{product.get('strings').negotiateHeading}</ks-product-button>
                            </ks-product-negotiate>
                        : null}

                        {(installments.payuId && installments.payuKey) || installments.caParameters ?
                            <ks-product-installments name={installments.button}>
                                {installments.payuId && installments.payuKey ?
                                    <ks-product-calculator-payu
                                        price={product.get("currentPrice")}
                                        pos-id={installments.payuId}
                                        api-key={installments.payuKey}>
                                        <ks-product-button icon={installments.payuIcon}/>
                                    </ks-product-calculator-payu>
                                : null}

                                {installments.caParameters ?
                                    <ks-product-calculator-ca
                                        price={product.get("currentPrice")}
                                        parameters={installments.caParameters}>
                                        <ks-product-button icon={installments.caIcon}/>
                                    </ks-product-calculator-ca>
                                : null}
                            </ks-product-installments>
                        : null}
                    </div>

                    <ks-product-brand slot="brand"/>
                </ks-product-info>
            </ks-container>

            {productBanner && productBanner?.image ?
                <ks-container>
                    <ks-content-info-banner productBanner={productBanner} />
                </ks-container>
            : null}

            {tags?.length > 0 || variants?.length > 0 ?
                <ks-container padding>
                    {tags?.length > 0 && !(variants?.length > 0) ?
                        <ks-product-tags />
                    : null}

                    {variants?.length > 0 ?
                        <ks-product-variants />
                    : null}
                </ks-container>
            : null}

            {tabs?.length > 0 ?
                <ks-container>
                    <ks-product-tabs names={tabs.map(tab => tab.name).join(", ")}>
                        {tabs.map((tab, index) => 
                            <ks-product-tab name={tab.name} open={index==0} main={index==0} content={tab.content} gspr={tab.gspr} />
                        )}
                    </ks-product-tabs>
                </ks-container>
            : null}

            {gspr.files?.length > 0 ?
                <ks-container padding center>
                    {gspr.files.map(file => 
                        <ks-button class="file" round newtab nofollow link={file.url} name={file.name} style={{width: "100%", maxWidth: "300px"}}/>
                    )}
                </ks-container>
            : null}

            {product.get('reviewProducts')?.length > 0 ?
                <ks-container>
                    <ks-review-product />
                </ks-container>
            : null}

            {tags?.length > 0 && variants?.length > 0 ?
                <ks-container padding>
                    <ks-product-tags/>
                </ks-container>
            : null}

            {youtube ?
                <ks-container>
                    {youtube.map(id => <ks-product-youtube video-id={id} />)}
                </ks-container>
            : null}

            {similar?.length > 0 ? [
                    <span class="listing-heading">{strings.similarHeading}</span>,
                    <ks-product-container>
                        {similar.map(card => 
                            <ks-product-card flat product={card}/>
                        )}
                    </ks-product-container>]
            : null}

            {accessories?.length > 0 ? [
                <span class="listing-heading">{strings.accessoriesHeading}</span>,
                <ks-product-container>
                    {accessories.map(card => 
                        <ks-product-card flat product={card}/>
                    )}
                </ks-product-container>
            ] : null}

            {review ?
                <ks-content-reviews content={review} />
            : null}
        </ks-page-base>;
	}
}




